import { cn } from "@rosette/ts/src/util/cn.js";
import type { ReactNode } from "react";
import { Slider } from "./Slider.js";


interface VolumeControlProps {
    className?: string;
    id: string;
    name?: string;
    volume: number;
    setVolume: (volume: number) => void;
    children: ReactNode;
}


export function VolumeControl({
    className, id, name, volume, setVolume, children,
}: VolumeControlProps) {
    return (
        <div className={cn("my-4 flex flex-row items-center", className ?? null)}>
            <label className="mr-3 flex cursor-pointer flex-row items-center text-base text-strong" htmlFor={id}>
                {children}
            </label>

            <div className="flex grow flex-row items-center justify-center [&_input]:max-w-[12em] [&_input]:grow">
                <Slider
                    id={id}
                    name={name}
                    min={0}
                    max={100}
                    value={volume}
                    setValue={setVolume} />

                <span className="ml-3 grow-0 cursor-pointer text-base font-normal">
                    {`${volume}%`}
                </span>
            </div>
        </div>
    );
}
